import { z } from "zod/v4";
import { AddressType } from "../../shipping/index.js";
import { OptionalEmailSchema } from "./email-schema.js";
import { KeyValuePairSchema } from "../../client/index.js";
const emptyToUndefined = (schema) => z.preprocess((v) => (v === "" ? undefined : v), schema);
const AddressInputShared = {
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    street: z.string().min(1),
    postalCode: z.string().min(1),
    city: z.string().min(1),
    country: z.string().min(1),
    email: OptionalEmailSchema,
};
export const AddressInputSchema = z.strictObject({
    ...AddressInputShared,
    phone: z.string().min(1),
    meta: z.array(KeyValuePairSchema).optional(),
});
export const AddressInputBackofficeSchema = z.strictObject({
    ...AddressInputShared,
    phone: emptyToUndefined(z.string().min(1).optional()),
    meta: z.array(KeyValuePairSchema).optional(),
});
export const AddressInputOrganizationSchema = z.strictObject({
    street: z.string().min(1),
    postalCode: z.string().min(1),
    city: z.string().min(1),
    country: z.string().min(1),
    email: OptionalEmailSchema,
    meta: z.array(KeyValuePairSchema).optional(),
});
export const AddressSchema = z.strictObject({
    type: z.enum(AddressType),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    street: z.string().min(1),
    postalCode: z.string().min(1),
    city: z.string().min(1),
    country: z.string().min(1),
    phone: z.string().min(1), // required
    email: OptionalEmailSchema,
    meta: z.array(KeyValuePairSchema).optional().nullable(),
});
export const AddressOrganizationSchema = AddressSchema.omit({
    firstName: true,
    lastName: true,
    phone: true,
}).extend({
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    phone: z.string().nullable(),
    meta: z.array(KeyValuePairSchema).nullable(),
});
export const AddressBackofficeSchema = AddressSchema.extend({
    phone: z.string().min(1).nullable().optional(),
});
